import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TenantWebchatConfigurationComponent } from '../tenant-webchat-configuration/tenant-webchat-configuration.component';
import { MarketplaceManagerService } from 'src/app/services/marketplace-manager.service';
import { SharedFeaturesService } from 'src/app/services/shared-features.service';
import { BaseManageConfiguration } from '../base-manage-configuration';

@Component({
  selector: 'app-manage-webchat',
  template: `
    <div class="mw-page">
      <div class="mw-head">
        <span class="mw-head-ico" aria-hidden="true">💬</span>
        <div class="mw-head-txt">
          <h3>Webchat</h3>
          <p>{{ configuredWebChat?.length || 0 }} tenant webchats configured</p>
        </div>
        <button type="button" class="btn-primary" (click)="addWebChat()">
          + Add webchat
        </button>
      </div>

      <div class="mw-grid">
        <div class="mw-card" *ngFor="let wc of configuredWebChat">
          <div class="mw-card-top">
            <span class="mw-tenant">{{ wc.tenant }}</span>
            <span class="mw-pill">Active</span>
            <span class="mw-actions">
              <button
                type="button"
                class="z-icb"
                matTooltip="Edit"
                (click)="updateWebChat(wc)"
              >
                <mat-icon>edit</mat-icon>
              </button>
              <button
                type="button"
                class="z-icb danger"
                matTooltip="Delete"
                (click)="deleteWebChat(wc.tenant)"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </span>
          </div>
          <div class="mw-bot">
            Bot <b>{{ wc.bot_name }}</b>
          </div>
          <span class="mw-chip" [matTooltip]="wc.webchat_build_url">{{
            wc.webchat_build_url | namingsize : 40
          }}</span>
        </div>

        <button type="button" class="mw-empty" (click)="addWebChat()">
          + Add webchat for a tenant
        </button>
      </div>
    </div>
  `,
  styleUrls: ['./manage-webchat.component.scss'],
})
export class ManageWebchatComponent extends BaseManageConfiguration implements OnInit {
  configuredWebChat: any;

  constructor(
    dialog: MatDialog,
    marketplaceManagerServices: MarketplaceManagerService,
    sharedServices: SharedFeaturesService
  ) {
    super(dialog, marketplaceManagerServices, sharedServices);
  }

  ngOnInit(): void {
    this.refreshWebChat();
  }

  refreshWebChat(): void {
    this.marketplaceManagerServices.getConfiguredWebChat().subscribe({
      next: (response: any) => {
        this.configuredWebChat = response;
      },
      error: (error: any) => {
        console.error('An error occurred', error);
      },
    });
  }

  addWebChat(): void {
    const deployForm = this.dialog.open(TenantWebchatConfigurationComponent, {
      disableClose: false,
      width: '480px',
      maxWidth: '92vw',
      panelClass: 'webchat-dialog',
    });
    this.handleConfigureDialog(
      deployForm,
      (result) => this.marketplaceManagerServices.configureWebChat(result),
      () => this.refreshWebChat()
    );
  }

  updateWebChat(webChatData: any): void {
    const deployForm = this.dialog.open(TenantWebchatConfigurationComponent, {
      data: webChatData,
      disableClose: false,
      width: '480px',
      maxWidth: '92vw',
      panelClass: 'webchat-dialog',
    });
    this.handleConfigureDialog(
      deployForm,
      (result) => this.marketplaceManagerServices.configureWebChat(result),
      () => this.refreshWebChat()
    );
  }

  deleteWebChat(name: string): void {
    this.handleDeleteConfirm(
      name,
      `Are you sure you want to delete '${name}' web-chat ?`,
      (n) => this.marketplaceManagerServices.deleteConfiguredWebChat(n),
      () => this.refreshWebChat()
    );
  }
}
